var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-section-title',{attrs:{"title":_vm.profile.name_display}}),_c('router-view',{on:{"update":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }